module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Brassiere-41abfdd16308b66dcccb261633794cf3.svg";